<div class="form-group" *ngIf="!forTimeslot && !forAmendFlight">
  <input class="form-control"
        [ngClass]="{ 'has-error' : customDate.invalid && customDate.dirty }"
        name="customDate"
        id="customDate"
        type="text"
        #dp="ngx-mydatepicker"
        #customDate="ngModel"
        [(ngModel)]="dateInput"
        ngx-mydatepicker
        [options]="myOptions"
        (ngModelChange)="dateChanged($event)"
        required>
  <label class="control-label" for="customDate">{{ labelText }}</label>
  <div class="form-group--links">
    <a class="btn btn-link" href="javascript:void(0)" (click)="dp.toggleCalendar()"><i class="icon">calendar</i></a>
  </div>
  <p class="help-block text-danger" *ngIf="customDate.invalid && customDate.dirty">{{ dateError }}</p>
</div>

<ng-container  *ngIf="forAmendFlight">
  <!-- <input class="form-control"
        class="hidden"
        name="customDate"
        id="customDate"
        type="text"
        #dp="ngx-mydatepicker"
        #customDate="ngModel"
        [(ngModel)]="dateInput"
        ngx-mydatepicker
        [options]="myOptions"
        (ngModelChange)="dateChanged($event)"
        required>
        -->
        <dp-date-picker
          #datePicker
          theme="dp-portrTheme-default"
          [config]="datePickerConfig"
          (onChange)="dateChanged($event)"
          >
        </dp-date-picker>
        <span class="placholder"  (click)="toggleDatePicker()"></span>


</ng-container>

<div *ngIf="forTimeslot">
  <!-- <input
    class="hidden"
    name="customDate"
    id="customDate"
    type="text"
    #dp="ngx-mydatepicker"
    [(ngModel)]="dateInput"
    ngx-mydatepicker
    [options]="myOptions"
    [defaultMonth]="defaultMonth"
    (dateChanged)="dateChanged($event)"
    hidden>
  <input type="radio"
    name="date"
    id="dateCalendar"
    [value]="dateInput"
    [ngModel]="dateInput"
    (keyup.enter)="dp.toggleCalendar()"
    required>

    -->
    <dp-date-picker
          #datePickerTimeSlot
          theme="dp-portrTheme-default"
          [config]="datePickerConfigTimeSlot"
          (onChange)="dateChanged($event)"
          >
        </dp-date-picker>
  <label
    class="flex"
    (click)="toggleDatePickerTimeslot()">
    <ng-container *ngIf="!selectedDate">
      <i class="icon">calendar</i>
      <p class="label__date">{{ labelText }}</p>
    </ng-container>
    <p class="radio--calendar__display" *ngIf="selectedDate">
      <span>{{ selectedDate | amDateFormat: 'ddd' }}</span>
      <span>{{ selectedDate | amDateFormat: 'D' }}</span>
      <span>{{ selectedDate | amDateFormat: 'MMM' }}</span>
    </p>
  </label>
</div>
